import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 初始化 && 计算同步参数
 * 提供 setData sendData 方法
 */
import lego from "../../../lego";
import legoDev from "../../legoDev";
import { LogError } from "../../utils";
import { initBase } from "./base";
import { initPerf } from "./perf";
import { initResource } from "./resource";
import { getCookie } from "../../../utils/cookie";

// 作为全局参数共享
// const ctx: Params= {};
var params = {
  backup: {}
};
// 存放用户自定义的数据，用于人工自定义上报，比计算的 params.backup 数值优先级高
var store = {};
var NOOP = function NOOP() {};
var forceMergeStore = function forceMergeStore(params) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  Object.assign(params.backup, store);
};

// 初始化 params 数据
export var initParams = function initParams() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Object.assign(ctx, opts, { params })
  // LogInfo('初始化配置', params);
  if (!performance) return LogError('performance 不存在');
  // 基础数据
  initBase(params, opts);
  // 页面性能数据
  initPerf(params);
  // 资源性能数据
  initResource(params, opts);
  // 合并用户自定义发送参数
  forceMergeStore(params, store);
  // 预渲染页参数特殊处理
  setPrerenderData(params, store);
  // fix isFirst params
  var loadcnt = getCookie("".concat(params.pagetype, "-isindex")) || 0;
  document.cookie = "".concat(params.pagetype, "-isindex=").concat(++loadcnt);
  params.backup.isFirst = loadcnt > 1 ? 0 : 1;
  //
  var _params = JSON.parse(JSON.stringify(params));
  return _params;
};
export var setPrerenderData = function setPrerenderData(params) {
  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (params.backup.isprerender == 1) {
    // 白屏参数设置默认值
    params.backup.blankTime = 1; // 默认 1ms，0 会被视为异常数据过滤
    // domReady 时间
    params.backup.readyTime = (store === null || store === void 0 ? void 0 : store.readyTime) || 100;
    // ssr 的首屏时间
    params.backup.firstPiantTime = (store === null || store === void 0 ? void 0 : store.firstPiantTime) || 100;
    // 如果没有计算首屏时间，则给默认值 100ms
    params.backup.atfTime = params.backup.fmp = (store === null || store === void 0 ? void 0 : store.atfTime) || (store === null || store === void 0 ? void 0 : store.fmp) || 100;
    // 完全加载时间
    params.backup.loadTime = (store === null || store === void 0 ? void 0 : store.loadTime) || 100;
    // other ..
  }
};

// 对外提供set, 方便异步数据赋值 和 扩展 backup 字段
export var setData = function setData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  Object.assign(params.backup, data);

  // LogInfo('setData', data)
  // 用户自定义的参数，暂存到 store ，用于最终数据合并，优先级最高
  if (forceUpdate) Object.assign(store, data);
};
export var sendData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var options,
      forbidSend,
      _params,
      _options$beforeSend,
      beforeSend,
      isCan,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
          forbidSend = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
          _context.next = 4;
          return Promise.resolve();
        case 4:
          if (!(!performance || forbidSend)) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return");
        case 6:
          _params = initParams(options);
          _options$beforeSend = options.beforeSend, beforeSend = _options$beforeSend === void 0 ? NOOP : _options$beforeSend; // LogInfo('发送 perf 数据', _params)
          isCan = beforeSend(_objectSpread({}, _params));
          if (!(isCan === false)) {
            _context.next = 11;
            break;
          }
          return _context.abrupt("return");
        case 11:
          lego.send(_objectSpread({}, _params));
          window['SCORE_ITEMS_PERF_DATA'] = _params;
          legoDev();
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function sendData() {
    return _ref.apply(this, arguments);
  };
}();